import React from 'react';
import { errorMessageStyles } from '../../styles/commonStyles';

/**
 * Компонент для отображения сообщений об ошибках
 * @param {Object} props - Свойства компонента
 * @param {string} props.message - Текст сообщения об ошибке
 * @returns {JSX.Element|null} Компонент сообщения об ошибке или null, если сообщение отсутствует
 */
const ErrorMessage = ({ message }) => {
  if (!message) return null;
  
  return (
    <div className={errorMessageStyles}>
      {message}
    </div>
  );
};

export default ErrorMessage; 